import { useState, useEffect, useContext } from 'react';
import { Nav, NavItem, NavLink, TabContent, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import DatosAlumno from './DatosAlumno';
import ActividadesGrupos from './ActividadesGrupos';
import Comentarios from './Comentarios';
import Historico from './Historico';
import Acciones from './Acciones';
import Recibos from './Recibos';
import Loader from '../../../layouts/loader/Loader';
import ModalAviso from '../../../layouts/modals/ModalAviso';
import { AuthContext } from '../../../context/authContext';

import '../../../assets/styles/login/login.css';
import matriculacionApiService from '../../../services/http/matriculacionApiService';
import { getItem, STORAGE_KEYS } from '../../../services/storage';

const ResumenSol = ({ idMatricula, setIdUsuario, setNombreAlumno, handleOnClick }) => {
  const [curso, setCurso] = useState('');
  const [ccodcli, setCcodcli] = useState('');
  const [listadoRecibos, setListadoRecibos] = useState([]);
  const [sumatorio, setSumatorio] = useState(0);
  const [sumatorioSuelto, setSumatorioSuelto] = useState(0);
  const [sumatorio2, setSumatorio2] = useState(0);
  const [sumatorioSuelto2, setSumatorioSuelto2] = useState(0);
  const [modulos, setModulos] = useState([]);
  const [activity, setActivity] = useState({});
  const [modulosDirty, setModulosDirty] = useState(false);
  const markModulosDirty = () => setModulosDirty(true);
  const [disableInput, setDisableInput] = useState(false);
  const enrollmentSession = getItem(STORAGE_KEYS.ENROLLMENT);
  const [comentarios, setComentarios] = useState('');
  const [invalidComentarios, setInvalidComentarios] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isNoPresencial, setIsNoPresencial] = useState(null);
  const { userOU } = useContext(AuthContext);
  const [hoursCounter, setHoursCounter] = useState(0);
  const [activeTab, setActiveTab] = useState('1');
  const [data, setData] = useState('');
  const [allFirstYearChecked, setAllFirstYearChecked] = useState(false);
  const [allSecondYearChecked, setAllSecondYearChecked] = useState(false);
  const [precioFinal, setPrecioFinal] = useState(0);
  const [excepcionFCT, setExcepcionFCT] = useState('0');

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  useEffect(() => {
    const fetchData = async () => {
      if (userOU.centro !== '') {
        try {
          const dataMatricula = await matriculacionApiService.detalleMatricula({
            headquarter: enrollmentSession.headquarter,
            id: idMatricula,
          });

          setIdUsuario(dataMatricula[0].idusuario);
          if (setNombreAlumno && dataMatricula[0].sNombre && dataMatricula[0].sApellidos) {
            setNombreAlumno(`${dataMatricula[0].sNombre} ${dataMatricula[0].sApellidos}`);
          }
          const adminCentros = new Set([
            'SUPERADMIN',
            'CNTEC Girona',
            'CEDESCA',
            'CNTEC Sevilla',
            'SECRETARÍA',
            'SECRETAR\u00cdA',
            'SECRETARIA',
          ]);
          // Verificar si el centro está en la lista de centros de administración
          if (adminCentros.has(userOU.centro) && dataMatricula[0].estado === 'Revisar delegación') {
            // Si el centro está en la lista de centros de administración y el estado es 'Revisar delegación'
            setDisableInput(true);
          } else if (
            !adminCentros.has(userOU.centro) &&
            dataMatricula[0].estado === 'Revisar secretaria'
          ) {
            // Si el estado es 'Revisar secretaria' o 'Activa'
            setDisableInput(true);
          } else if (
            dataMatricula[0].estado === 'Baja' ||
            dataMatricula[0].estado === 'Pendiente Baja'
          ) {
            setDisableInput(true);
          } else if (!adminCentros.has(userOU.centro) && dataMatricula[0].estado === 'Activa') {
            setDisableInput(true);
          }

          // Guardamos el nombre del curso
          setCurso(dataMatricula[0].curso);
          setIsNoPresencial(dataMatricula[0].IdModalidadFormacion !== 0);
          setCcodcli(dataMatricula[0].ccodcli);
          setData(dataMatricula[0]);

          setIsLoading(false);
        } catch (error) {
          setIsLoading(false);
        }
      }
    };

    fetchData();
  }, [enrollmentSession?.headquarter, idMatricula, setIdUsuario, setNombreAlumno, userOU.centro]);

  useEffect(() => {
    const checkAllYears = () => {
      let firstYearChecked = true;
      let secondYearChecked = true;

      Object.entries(activity).forEach(([, array]) => {
        array.forEach((obj) => {
          const value = `${obj.modulo} ${obj.descripcion}`;
          if (obj.curso === 'PRIMERO' && !modulos.includes(value)) {
            firstYearChecked = false;
          }
          if (obj.curso === 'SEGUNDO' && !modulos.includes(value)) {
            secondYearChecked = false;
          }
        });
      });

      setAllFirstYearChecked(firstYearChecked);
      setAllSecondYearChecked(secondYearChecked);
    };

    checkAllYears();
  }, [modulos, activity]);

  let id = idMatricula;

  if (idMatricula === undefined) {
    id = getItem(STORAGE_KEYS.ENROLLMENT)?.id;
  }

  return (
    <>
      {!isLoading &&
      userOU.centro !== '' &&
      (userOU.centro === 'SUPERADMIN' ||
        userOU.centro === 'SECRETARÍA' ||
        userOU.centro === 'SECRETAR\u00cdA') &&
      data.estado === 'Baja' &&
      data.cantidadRecibos > 0 ? (
        <ModalAviso toggle={toggle} header="Matrícula con recibos pendientes." />
      ) : (
        ''
      )}
      {!isLoading && userOU.centro !== '' ? (
        <>
          <Nav tabs>
            <NavItem>
              <NavLink
                className={activeTab === '1' ? 'active' : ''}
                onClick={() => {
                  toggle('1');
                }}
              >
                Datos matrícula
              </NavLink>
            </NavItem>
            {(userOU.centro === 'SUPERADMIN' ||
              userOU.centro === 'SECRETARÍA' ||
              userOU.centro === 'SECRETAR\u00cdA') &&
            data.estado !== 'Revisar secretaria' &&
            data.estado !== 'Revisar delegación' ? (
              <NavItem>
                <NavLink
                  className={activeTab === '2' ? 'active' : ''}
                  onClick={() => {
                    toggle('2');
                  }}
                >
                  Recibos
                </NavLink>
              </NavItem>
            ) : (
              ''
            )}
          </Nav>
          {activeTab === '1' ? (
            <>
              <TabContent className="p-4" activeTab={activeTab}>
                <DatosAlumno
                  idMatricula={id}
                  precioFinal={precioFinal}
                  exepcion={excepcionFCT}
                  setExepcion={setExcepcionFCT}
                />
                {ccodcli !== '' ? (
                  <ActividadesGrupos
                    setPrecioFinal={setPrecioFinal}
                    isNoPresencial={isNoPresencial}
                    setModulos={setModulos}
                    markModulosDirty={markModulosDirty}
                    id={id}
                    activity={activity}
                    setActivity={setActivity}
                    empresaId={getItem(STORAGE_KEYS.ENROLLMENT)?.headquarter}
                    modulos={modulos}
                    sumatorio={sumatorio}
                    setSumatorio={setSumatorio}
                    sumatorioSuelto={sumatorioSuelto}
                    setSumatorioSuelto={setSumatorioSuelto}
                    sumatorio2={sumatorio2}
                    setSumatorio2={setSumatorio2}
                    sumatorioSuelto2={sumatorioSuelto2}
                    setSumatorioSuelto2={setSumatorioSuelto2}
                    idMatricula={idMatricula}
                    estado={disableInput}
                    hoursCounter={hoursCounter}
                    setHoursCounter={setHoursCounter}
                    ccodcli={ccodcli}
                    allFirstYearChecked={allFirstYearChecked}
                    allSecondYearChecked={allSecondYearChecked}
                  />
                ) : (
                  ''
                )}

                {userOU.centro === 'ORIENTACIÓN' ? (
                  ''
                ) : (
                  <Comentarios
                    setComentarios={setComentarios}
                    setInvalidComentarios={setInvalidComentarios}
                    invalidComentarios={invalidComentarios}
                  />
                )}
                <Historico />
              </TabContent>
            </>
          ) : (
            <TabContent className="p-4" activeTab={activeTab}>
              <Recibos
                listadoRecibos={listadoRecibos}
                setListadoRecibos={setListadoRecibos}
                idMatricula={id}
                ccodcli={ccodcli}
              />
            </TabContent>
          )}

          {userOU.centro === 'ORIENTACIÓN' || activeTab === '2' ? (
            <Button className="float-end me-1" onClick={handleOnClick}>
              Atrás
            </Button>
          ) : (
            <Acciones
              isNoPresencial={isNoPresencial}
              curso={curso}
              comentarios={comentarios}
              modulos={modulos}
              activity={activity}
              hoursCounter={hoursCounter}
              precioFinal={precioFinal}
              excepcionFCT={excepcionFCT}
              modulosDirty={modulosDirty}
            />
          )}
        </>
      ) : (
        <Loader />
      )}
    </>
  );
};
ResumenSol.propTypes = {
  idMatricula: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setIdUsuario: PropTypes.func,
  setNombreAlumno: PropTypes.func,
  handleOnClick: PropTypes.func,
};
export default ResumenSol;
